import React from 'react';
import { createPortal } from 'react-dom';
import { AlertTriangle, HelpCircle } from 'lucide-react';
import { Btn, Modal } from '../../components/UI';

// The HR confirmation box, in place of the browser's window.confirm. Screens ask through
// useHR().confirm({ title, message, confirmLabel, danger }), which resolves true or false.
export default function ConfirmDialog({ title = 'Please confirm', message, detail, confirmLabel = 'Confirm', cancelLabel = 'Cancel', danger, onAnswer }) {
  const Icon = danger ? AlertTriangle : HelpCircle;
  const tone = danger ? 'var(--red, #dc2626)' : 'var(--accent, #0b318b)';
  // on <body>, after any open HR modal, so it always shows on top of the screen that asked
  return createPortal(
    <Modal title={title} onClose={() => onAnswer(false)} width={460} blur={2}>
      <div style={{ display: 'flex', gap: 14, alignItems: 'flex-start', padding: '6px 4px 18px' }}>
        <span style={{ width: 42, height: 42, flexShrink: 0, borderRadius: 12, display: 'grid', placeItems: 'center', color: tone,
                       background: danger ? 'rgba(220,38,38,0.1)' : 'rgba(11,49,139,0.1)' }}>
          <Icon size={22} />
        </span>
        <div style={{ minWidth: 0 }}>
          <div style={{ fontSize: 14.5, fontWeight: 600, color: 'var(--text-primary)', lineHeight: 1.45, overflowWrap: 'anywhere' }}>{message}</div>
          {detail && <div style={{ fontSize: 13, color: 'var(--text-secondary)', marginTop: 6, lineHeight: 1.45 }}>{detail}</div>}
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, borderTop: '1px solid var(--border-light, #e2e8f0)', paddingTop: 14 }}>
        <Btn variant="secondary" onClick={() => onAnswer(false)}>{cancelLabel}</Btn>
        <Btn variant={danger ? 'danger' : 'primary'} onClick={() => onAnswer(true)}
             style={danger ? { background: 'var(--red, #dc2626)', color: '#fff', border: '1px solid var(--red, #dc2626)' } : undefined}>{confirmLabel}</Btn>
      </div>
    </Modal>,
    document.body,
  );
}
